import { Component, OnInit, Input } from '@angular/core';
import { Router} from "@angular/router";
import { AssessmentsService } from '../../service/entity-services/assessments.service';
import { EntityList } from '../../objects/entity-list';
import { MatDialog } from '@angular/material/dialog';

import { AssessmentViewerComponent } from '../../secure/entity-viewers/assessment-viewer/assessment-viewer.component';
import { PartyService } from '../../service/entity-services/party.service';
import { ToastMessageDialog } from '../../toolbar-components/toolbar-utilities/view-utilities';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContractService } from '../../service/entity-services/contract.service';

import * as assessmentColumns from '../../shared/entity-columns/assessment-columns';
import { NewRiskAssessmentComponent } from '../../create-new/new-risk-assessment/new-risk-assessment.component';
import { environment } from '../../../environments/environment';
import { DatabaseAction, EntityState, EntityType } from '../../objects/interface-library';
import { NewAttachmentComponent } from '../../create-new/new-attachment/new-attachment.component';
import { AttachmentViewerComponent } from '../../secure/entity-viewers/attachment-viewer/attachment-viewer.component';

import { AgGridModule } from 'ag-grid-angular';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';



let _ = require('lodash');


@Component({
    selector: 'app-assessment-list',
    templateUrl: './assessment-list.component.html',
    styleUrls: ['./assessment-list.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      MatSidenavModule,
      MatDividerModule
    ]
  })
export class AssessmentListComponent extends EntityList implements OnInit {

  currentAssessment = null;
  currentContract = null;
  currentParty = null;

  attestation = null;

  linkToContractFile = null;
  assessmentStatuses = null;

  averageScore = 0;
  totalScore = 0;
  assessmentInstructions = null;

  partyFriendlyName = null;

  scores = null;
  questions = null;
  assessmentQuestionsOne = null;
  assessmentQuestionsTwo = null;
  assessmentTypes = null;
  assessmentRequiredActions = null;
  assessmentAllStatusTypes = null;

  attachmentGridApi = null;
  assessmentHistoryGridApi = null;

  assessmentHistory = [];
  attachmentObjectArray = [];  
  allAssessmentsThisEntity = [];

  public assessmentList = [];
  filteredAssessmentList = [];
  selectedFilters = [];
  waitingForFilterResults = false;

  defaultUserViewCols = [
      assessmentColumns.colAssessors,
      assessmentColumns.colOwner,
      assessmentColumns.colFinalReviewer,
      assessmentColumns.colAssessmentName,
      assessmentColumns.colAssessmentPartyName,
      assessmentColumns.colAssessmentType,
      assessmentColumns.colStatus,
      assessmentColumns.colContractId,
      assessmentColumns.colSourceRecord,
      assessmentColumns.colCriticalDate
  ];  

  assessmentHistoryColumns = [
    {
      colId: 'assessmentName',
      headerName: 'Name',
      field: 'name',
      width: 100
    },
    {
      colId: 'assessmentType',
      headerName: 'Type',
      field: 'type',
      hide: false,
      width: 100
    },
    {
      colId: 'status',
      headerName: 'Status',
      field: 'status',
      width: 50
    },
    assessmentColumns.colOwner,
    // {
    //   colId: 'owner',
    //   headerName: 'Owner',
    //   field: 'owner',
    //   width: 100
    // },
    assessmentColumns.colAssessors,
    assessmentColumns.colCriticalDate
  ]


  attachmentColumns = [
    {
      colId: 'attachmentName',
      headerName: 'Attachment Name',
      field: 'name',
      width: 100
    },
    {
      colId: 'type',
      headerName: 'Type',
      field: 'attachmentType',
      width: 50
    },
    {
      colId: 'owner',
      headerName: 'Owner',
      field: 'attachmentData.owner',
      width: 100
    },
    {
      colId: 'attachmentDescription',
      headerName: 'Description',
      field: 'description',
      hide: false,
      width: 100
    },
    // {
    //     colId: 'attachmentView',
    //     headerName: 'Download Link',
    //     field: 'View in New Tab',
    //     hide: false,
    //     width: 100
    // }
  ]



  constructor(public router: Router,
              public dialog: MatDialog,
              private _snackBar: MatSnackBar,
              public assessmentsService: AssessmentsService) {

    super();
}

  async ngOnInit() {

    // let assessmentResponse = await this.assessmentsService.getAssessments();

    // BUGBUG:  this needs pagination!!!
    // this.assessmentList = assessmentResponse.data;

    // if (this.gridApi) {
    //   this.gridApi.sizeColumnsToFit();
    // }

    // await this.assessmentsService.getAllAssessments();
    // this.globalDataService.allParties = await this.partyService.getAllParties();

    // await this.getGoogleSheetsStaticData();
  }







  async processAllAssessments() {

    // if (this.filteredAssessmentList && this.filteredAssessmentList.length > 0) {

    //   this.filteredAssessmentList.forEach( async assessment => {

    //     if (assessment.partyNum) {
    //       assessment.partyFriendlyName = await this.globalDataService.getPartyFriendlyName(assessment.partyNum);
    //       // console.log('*** process party: ', assessment.partyFriendlyName);
    //       // this.gridApi.setRowData(this.filteredAssessmentList);
    //       // this.gridApi.sizeColumnsToFit();
    //     }

    //   });

    // } // end of if filteredAssessmentList > 0 

  }




  filterChanged(filterList) {

    this.selectedFilters = filterList;
    this.updateUserView();

  }


  async updateUserView() {

    // // Query assessments field already does this in the first line
    // // await this.assessmentsService.getAllAssessments();

    //   // Use SRH style email if you are SRH and you are SSO
    //   const emailToLookFor = (environment.sso && environment.org === 'srh')
    //   ? await this.globalDataService.getSrhUserEmail(this.globalDataService.userId)
    //   : this.globalDataService.email;

    // this.waitingForFilterResults = true;

    // this.filteredAssessmentList = [];

    // if (this.selectedFilters.length > 0) {

    //   this.selectedFilters.forEach(async filter => {

    //     switch (filter) {
    //       case 'Owner':
    //           // let assessmentOwnerResponse = await this.assessmentsService.queryAssessmentsField('owner', this.globalDataService.userId);
    //           let assessmentOwnerResponse = await this.assessmentsService.queryAssessmentsField('owner', emailToLookFor);

    //           let onlyStatusNotReviewCompleted = assessmentOwnerResponse.filter( asmt => asmt.status != 'Approved' &&
    //                                                                                       asmt.status != 'Completed' &&
    //                                                                                       asmt.status != 'No Evaluation Required' &&
    //                                                                                       asmt.status != 'Action Plan Completed');

    //           this.filteredAssessmentList = this.filteredAssessmentList.concat(onlyStatusNotReviewCompleted);

    //           await this.processAllAssessments();
    //           this.waitingForFilterResults = false;

    //           this.gridApi.sizeColumnsToFit();

    //           break;

    //       case 'Assessor':

    //           console.log('*** Looking for Assessor: ', this.globalDataService.email);
    //           console.log('*** user ID: ', this.globalDataService.userId);
    //           console.log('*** all users: ', this.globalDataService.allUsers);

    //           // BUGBUG: Need to figure out what this is for:  await this.assessmentsService.queryAssessmentsList('assessor', this.globalDataService.userId));
    //           //          queryAssessmentsList doesn't work!
    //           //          Below is fine.
    //           let assessmentAssessorResponse = await this.assessmentsService.queryAssessmentsField('assessor', emailToLookFor);
    //           // let assessmentAssessorResponse = await this.assessmentsService.queryAssessmentsField('assessor', this.globalDataService.userId);

    //           // console.log('*** assessor assessments: ', assessmentAssessorResponse);

    //           let onlyStatusAssessmentPending = assessmentAssessorResponse.filter( asmt => asmt.status === 'Pending Completion' ||
    //                                                                                         asmt.status === 'In Progress' ||
    //                                                                                         asmt.status === 'In Remediation - CAP Pending' ||
    //                                                                                         asmt.status === 'In Remediation - Action Plan Pending');

    //           // ON OCT 28TH, 2023 RAY said to remove Action Plan Completed
    //           // let onlyStatusAssessmentPending = assessmentAssessorResponse.filter( asmt => asmt.status === 'Pending Completion' ||
    //           //                                                                                   asmt.status === 'In Progress' ||
    //           //                                                                                   asmt.status === 'In Remediation - Action Plan Pending' ||
    //           //                                                                                   asmt.status === 'Action Plan Completed');

    //           this.filteredAssessmentList = this.filteredAssessmentList.concat(onlyStatusAssessmentPending);

    //           await this.processAllAssessments();
    //           this.waitingForFilterResults = false;

    //           this.gridApi.sizeColumnsToFit();


    //           break;

    //       case 'Reviewer':
    //         let assessmentReviewerResponse = await this.assessmentsService.queryAssessmentsField('finalReviewer', emailToLookFor);
    //         // let assessmentReviewerResponse = await this.assessmentsService.queryAssessmentsField('finalReviewer', this.globalDataService.userId);

    //           let reviewerAssessmentPending = assessmentReviewerResponse.filter( asmt => asmt.status === 'Initial Assessment Completed' ||
    //                                                                               asmt.status === 'Completed' ||
    //                                                                               asmt.status === 'No Evaluation Required' ||
    //                                                                               asmt.status === 'Evaluation Completed' ||
    //                                                                               asmt.status === 'Action Plan Completed' ||
    //                                                                               asmt.status === 'CAP Completed - Ready for Final Reviewer' ||
    //                                                                               asmt.status === 'Evaluation Completed - Ready for Final Reviewer' ||
    //                                                                               asmt.status === 'Action Plan Pending');

                                                                                  

    //           this.filteredAssessmentList = this.filteredAssessmentList.concat(reviewerAssessmentPending);
  
    //           await this.processAllAssessments();
    //           this.waitingForFilterResults = false;

    //           this.gridApi.sizeColumnsToFit();


    //           break;
                
    //       // case 'Approver':
    //       //     let assessmentApproverResponse = await this.assessmentsService.queryAssessmentsField('finalReviewer', this.globalDataService.email);
    //       //     this.assessmentList = this.assessmentList.concat(assessmentApproverResponse.data);
  
    //       //     this.waitingForFilterResults = false;
    //       //     break;


    //       default:
    //         break;
    //     }

    //     this.assessmentList = _.uniqBy(this.assessmentList, 'assessmentNum');


    //   });
    // } else {
    //   this.waitingForFilterResults = false;
    // }
  }



  async assessmentDetails(event) {

    this.currentAssessment = event.data.assessmentData;

    const dialogRef = this.dialog.open(NewRiskAssessmentComponent, {
      width: '1500px',
      height: '700px',
      data: {
              assessmentObject: this.currentAssessment,
              readOnly: false
            }
    });

    dialogRef.afterClosed().subscribe(result => {

      this.updateUserView();
      this.refreshGrid();

    });

  }


  // async assessmentStatusSelectionChanged() {

  //   console.log('*** check status: ', this.currentAssessment);
  // }


  onScoreChange(selectedIndex: number, questionIndex: number): void {

    // Set the score to the selected index
    // this.currentAssessment.questionsAndAnswers[questionIndex].score = selectedIndex;
    // this.currentAssessment.questionsAndAnswers[questionIndex].scoreDescription = this.scores[selectedIndex];

    // this.totalScore = this.assessmentsService.calculateTotalScore(this.currentAssessment);
    // this.currentAssessment.totalScore = this.totalScore;
  }



  async assessmentClicked(event) {

    // this.currentAssessment = event.data.assessmentData;

    // console.log('*** Assessment Clicked: ', this.currentAssessment);
    // console.log('*** all assessments: ', this.globalDataService.allAssessments);
    
    // let foundAssessment = this.globalDataService.allAssessments.find( assessment => assessment.assessmentNum === this.currentAssessment.assessmentNum);

    // console.log('*** FOUND ASSESSMENT? ', foundAssessment);

    // this.attachmentObjectArray = [];
    // this.linkToContractFile = null;
    // // this.calculateScore();
    // // this.assessmentsService.calculateTotalScore(foundAssessment);


    // if (this.currentAssessment.entityType === EntityType.Contract) {
    //   this.currentContract = this.globalDataService.allContracts.find(contract => contract.contractId === this.currentAssessment.entityId);

    //   if (!this.currentContract) {
    //     this.currentContract = this.globalDataService.allContracts.find(contract => contract.contractNum === this.currentAssessment.entityId);
    //   }
    //   // this.currentContract = await this.contractManagerService.getContractByNumber(this.currentContract.contractNum);

    //   for (const attachmentNum of this.currentContract.attachments) {
    //     let attachmentObject = await this.contractManagerService.getAttachmentById(attachmentNum);
    //     if (attachmentObject && attachmentObject.attachmentData) {
    //       this.attachmentObjectArray.push(attachmentObject.attachmentData);
    //     }

    //     if (this.attachmentGridApi) {
    //       this.attachmentGridApi.setRowData(this.attachmentObjectArray);
    //       this.attachmentGridApi.sizeColumnsToFit();  
    //     }
    //   }

    //   if (!this.currentContract.directVendor.vendorNum) {
    //     this.currentParty = await this.contractManagerService.getPartyByNum(this.currentContract.directVendor);
    //     if (this.currentParty.vendorData) {
    //       this.currentParty = this.currentParty.vendorData;
    //     }
    //   } else if (this.currentContract.directVendor) {
    //     this.currentParty = this.currentContract.directVendor;
    //   }

    //   this.allAssessmentsThisEntity = this.globalDataService.allAssessments.filter(assessment => assessment.entityId === this.currentContract.contractId);

    //   // console.log('*** CURRENT CONTRACT: ', this.currentContract);

    // } else if (this.currentAssessment.entityType === EntityType.Party) {

    //   this.currentParty = await this.contractManagerService.getPartyByNum(this.currentAssessment.entityId);

    //   console.log('*** CURRENT PARTY: ', this.currentParty);

    //   this.currentParty = this.currentParty.vendorData;

    //   if (this.currentParty.attachments) {

    //     for (const attachmentNum of this.currentParty.attachments) {
    //       let attachmentObject = await this.contractManagerService.getAttachmentById(attachmentNum);

    //       if (attachmentObject && attachmentObject.attachmentData) {
    //         this.attachmentObjectArray.push(attachmentObject.attachmentData);
    //       }

    //       if (this.attachmentGridApi) {
    //         this.attachmentGridApi.setRowData(this.attachmentObjectArray);
    //         this.attachmentGridApi.sizeColumnsToFit();  
    //       }
    //     }

    //   }

    //   this.allAssessmentsThisEntity = this.globalDataService.allAssessments.filter(assessment => assessment.entityId === this.currentAssessment.entityId);

    // }

    // if (this.currentContract && this.currentContract.contractFileName) {
    //   this.linkToContractFile = environment.s3Location + this.currentContract.contractFileName;
    // }


    // if (this.currentAssessment.owner && typeof this.currentAssessment.owner === 'string') {

    //   this.currentAssessment.owner = await this.getUserObject(this.currentAssessment.owner);

    // }

    // if (this.currentAssessment.assessor && typeof this.currentAssessment.assessor === 'string') {

    //   this.currentAssessment.assessor = await this.getUserObject(this.currentAssessment.assessor);

    // }

    // if (this.currentAssessment.finalReviewer && typeof this.currentAssessment.finalReviewer === 'string') {

    //   this.currentAssessment.finalReviewer = await this.getUserObject(this.currentAssessment.finalReviewer);

    // }

    // if (this.currentContract && this.currentContract.sites) {
    //   this.addSitesFriendlyNameToEntity(this.currentContract);
    // }

    // if (this.currentAssessment && this.currentAssessment.attachments && this.currentAssessment.attachments.length > 0) {
    //   for (const attachmentNum of this.currentAssessment.attachments) {
    //     let attachmentObject = await this.contractManagerService.getAttachmentById(attachmentNum);
    //     if (attachmentObject && attachmentObject.attachmentData) {
    //       this.attachmentObjectArray.push(attachmentObject.attachmentData);
    //     }

    //     if (this.attachmentGridApi) {
    //       this.attachmentGridApi.setRowData(this.attachmentObjectArray);
    //       this.attachmentGridApi.sizeColumnsToFit();  
    //     }
    //   }
    // }

    // // Add party friendly name
    // if (this.currentParty.name) {
    //   this.partyFriendlyName = this.currentParty.name;
    // }

    // this.assessmentHistoryGridApi.sizeColumnsToFit();

  }



  onAssessmentClickedHistoryGrid(event) {

    let historicAssessment = event.data.assessmentData;

    const dialogRef = this.dialog.open(NewRiskAssessmentComponent, {
      width: '1500px',
      height: '700px',
      data: {
              assessmentObject: historicAssessment,
              openReadOnly: true
            }
    });

    dialogRef.afterClosed().subscribe(result => {


    });
  }







  async getGoogleSheetsStaticData() {

    // this.scores = await this.assessmentsService.getAssessmentScores();
    // this.questions = await this.assessmentsService.getAssessmentQuestions();
    // this.assessmentStatuses = await this.assessmentsService.getAssessmentStatuses();
    // this.attestation = await this.assessmentsService.getAttestation();


    // this.googleSheetsService
    //     .getAssessmentQuestionsTwo()
    //     .then(sheetsResponse => {
    //       // console.log('sheets response --> ', sheetsResponse);
    //       this.assessmentQuestionsTwo = sheetsResponse.values[0];
    // });

    // this.assessmentTypes = await this.assessmentsService.getAssessmentTypes();

    // this.googleSheetsService
    //     .getAssessmentQuestionsOne()
    //     .then(sheetsResponse => {
    //       // console.log('sheets response --> ', sheetsResponse);
    //       this.assessmentQuestionsOne = sheetsResponse.values[0];
    // });

    // this.assessmentRequiredActions = await this.assessmentsService.getRequiredActions();

    // this.googleSheetsService
    //     .getAssessmentStatus()
    //     .then(sheetsResponse => {
    //       this.assessmentAllStatusTypes = sheetsResponse.values[0];
    // });

    // this.assessmentInstructions = await this.assessmentsService.getAssessmentInstructions();


  }


  async assessmentStatusSelectionChanged() {

    console.log('*** check assessment status: ', this.currentAssessment);
  }



  async saveAssessment() {
   
    // this.assessmentsService.assessmentSavedEmailTriggers(this.currentAssessment, this.currentContract, this.currentParty);

    // await this.assessmentsService.writeAssessment(this.currentAssessment);

    // this.globalDataService.toastMessage = 'Assessment Saved';

    // this._snackBar.openFromComponent(ToastMessageDialog, {
    //   duration: 5000,
    // });

    // this.currentAssessment = null;

    // this.updateUserView();

  }





  sliderThumbValue(value: number) {

    let returnValue = value - 1;
    let returnValueAsString = returnValue.toString();

    if (returnValue < 0) {
      returnValueAsString = 'N/A';
    }

    return returnValueAsString;

  }



  // // BUBUG:  not used but could be used in other places
  // goToContractLink(){
  //   // let contractUrl = environment.linkToDeployment + 'contract/' + this.currentContract.contractNum;
  //   // window.open(contractUrl, "_blank");
  // }


  // refreshGridList() {
  //   this.gridApi.setRowData(this.);
  //   // this.gridApi.sizeColumnsToFit();
  // }

  refreshGrid() {
    var params = {
      force: true,
      suppressFlash: false,
    };
    this.gridApi.refreshCells(params);
  }  


  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.api;
  }


  onAssessmentHistoryGridReady(params) {
    this.assessmentHistoryGridApi = params.api;
  }

  attachmentGridReady(params) {
    this.attachmentGridApi = params.api;
  }  


}
